import { useConfigStore } from '../store/config'

export interface ThemeType {
  colors: any
  shadows: any
  sm: string
  md: string
  lg: string
  xl: string
}

export const theme: ThemeType = {
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  colors: {
    secondary: '#646464',
    primary: '#E6E6E6',
    text: '#E6E6E6',
    background: '#FFFFFFF',
    placeholder: '#000000',
    title: '#E6E6E6',
    header: '#E6E6E6',
    default: '#1d222e',
    drawer: '#EFEFEF',
    label: '#E6E6E6',
    input: '#E6E6E6',
    border: '#e1e5eb',
    error: '#DE4848',
    warning: '#DEBD48',
    success: '#1a9e04',
    buttonLabel: '#FFFFFF',
  },

  shadows: {
    mediumShadow: 'box-shadow: 0px 4px 14px rgba(132, 201, 250, 0.07);',
  },
}
